// JobClose AI · Mohit QA Reporting V1 · Route guard.
//
// Feature-flagged capability guard for the /app/qa surface.
// Renders children only when the backend confirms the user has QA
// capability (or admin role) AND the feature flag is enabled.
import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { api } from "@/lib/api";

export default function QaScopeRoute() {
  const [state, setState] = useState({ loading: true, allow: false });
  useEffect(() => {
    let cancelled = false;
    api.get("/qa/entitlement")
      .then((res) => {
        if (cancelled) return;
        const d = res.data || {};
        const allow = Boolean(
          d.feature_enabled && (d.is_admin || d.can_submit_findings),
        );
        setState({ loading: false, allow });
      })
      .catch(() => {
        if (!cancelled) setState({ loading: false, allow: false });
      });
    return () => { cancelled = true; };
  }, []);
  if (state.loading) {
    return (
      <div
        data-testid="qa-scope-loading"
        className="min-h-[60vh] flex items-center justify-center text-sm text-[var(--jc-text-soft)]"
      >
        Checking QA access…
      </div>
    );
  }
  if (!state.allow) return <Navigate to="/app" replace />;
  return <Outlet />;
}
